import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Permite el acceso a /inicio únicamente cuando el entorno tiene
 * publicClient configurado. Si no, redirige a /not-found.
 *
 * De este modo un build sin cliente configurado no expone ninguna
 * landing pública, aunque el código de otros clientes esté en el bundle.
 */
export const landingGuard: CanActivateFn = () => {
  if (!environment.publicClient) {
    return inject(Router).createUrlTree(['/not-found']);
  }
  return true;
};
